import { PassengerType } from '../../interfaces/mybooking/passenger-type';
/**
 * 搭乗者種別のラベルを取得
 * @param code 搭乗者種別コード
 * @param notFind 見つからなかったときのラベル
 * @return 搭乗者種別のラベル
 */
export function getPassengerLabel(code: string) {
  switch (code) {
    case PassengerType.ADT:
      return 'label.adult';
    case PassengerType.B15:
      return 'label.youngAdult';
    case PassengerType.CHD:
      return 'label.child';
    case PassengerType.INF:
      return 'label.infant';
    case PassengerType.INS:
      return 'label.ins';
  }
  return '';
}

/**
 * 搭乗者種別のラベルを取得 搭乗者入力などで使用　文言がオリジナルのため作成
 * @param code 搭乗者種別コード
 * @return 搭乗者種別のラベル
 */
export function getPassengerLabel2(code: string) {
  // 搭乗者種別
  switch (code) {
    case PassengerType.ADT:
      return 'label.adult';
    case PassengerType.B15:
      return 'label.youngAdult.passengerInput';
    case PassengerType.CHD:
      return 'label.child2To11';
    case PassengerType.INF:
      return 'label.infant0To1';
  }
  return 'label.adult';
}

/**
 * 搭乗者種別のラベルを取得
 * @param code 搭乗者種別コード
 * @return 搭乗者種別のラベル
 */
export function getPassengerLabel3(code: string) {
  switch (code) {
    case PassengerType.ADT:
      return 'label.passengerAdult';
    case PassengerType.B15:
      return 'label.passengerYoungAdult';
    case PassengerType.CHD:
      return 'label.passengerChild';
    case PassengerType.INF:
      return 'label.passengerInfant';
    case PassengerType.INS:
      return 'label.passengerIns';
  }
  return '';
}

export function getNumPassenger(code: string) {
  // 搭乗者種別
  switch (code) {
    case PassengerType.ADT:
      return 'label.numPassenger.adult';
    case PassengerType.B15:
      return 'label.numPassenger.youngAdult';
    case PassengerType.CHD:
      return 'label.numPassenger.child';
    case PassengerType.INF:
      return 'label.numPassenger.infant';
  }
  return 'label.numPassenger.adult';
}
